import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ClientRoutingModule } from './client-routing.module';
import { HTTP_INTERCEPTORS } from '@angular/common/http';

// Interceptors
import { AuthorizationInterceptorService } from '../../interceptors/authorization-interceptor.service';
import { ConfigurationsModule } from './configurations/configurations.module';
import { FormsModule } from '@angular/forms';

@NgModule({
  declarations: [ ],
  imports: [
    FormsModule,
    CommonModule,
    ClientRoutingModule,
    ConfigurationsModule
  ],
  exports: [
    ClientRoutingModule,
    ConfigurationsModule
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: AuthorizationInterceptorService, multi: true}
  ]
})
export class ClientModule { }
